import { AgentApiRequestHelper } from '../agent-api-request-helper';
import type { CommendaAiMutationResult } from '../types';
import type {
  ICreateDocumentReaderUploadParams,
  IDocumentReaderUploadBatchCreatedResponse,
} from './types';

/** Opens a data-room upload with its first batch of files; each file gets its part count. */
export async function createDocumentReaderUpload(
  params: Readonly<ICreateDocumentReaderUploadParams>,
  signal?: AbortSignal
): Promise<
  CommendaAiMutationResult<IDocumentReaderUploadBatchCreatedResponse>
> {
  return AgentApiRequestHelper.mutate<IDocumentReaderUploadBatchCreatedResponse>(
    'agent-platform/document-reader/uploads',
    { method: 'POST', body: params, ...(signal ? { signal } : {}) },
    'Could not start the document upload.'
  );
}
